var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, Input } from '@angular/core';
import { ColumnBaseComponent } from '../../../../../items/columns/base/columnbase.component';
import { ColumnService } from '../../../../../items/columns/column/column.service';
import { ColumnBaseService } from '../../../../../items/columns/base/columnbase.service';
import { KtsDepartmentService } from './department.service';
var KtsDepartmentComponent = /** @class */ (function (_super) {
    __extends(KtsDepartmentComponent, _super);
    function KtsDepartmentComponent(service, baseService, departmentService) {
        var _this = _super.call(this, service, baseService) || this;
        _this.service = service;
        _this.baseService = baseService;
        _this.departmentService = departmentService;
        _this.departmentOptions = [];
        _this.sectionOptions = {};
        _this.unselectedOption = {};
        return _this;
    }
    KtsDepartmentComponent.prototype.ngOnChanges = function (changes) {
        // view
        if (changes.val && this.department && this.section) {
            this.setName();
        }
        this.setSection();
        _super.prototype.ngOnChanges.call(this, changes);
    };
    KtsDepartmentComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        // 一覧画面は必須選択を外し、未選択のラベルを設定する
        var requiredParam = jsonpath.value(this.col, '$.required') || '';
        if (requiredParam !== true) {
            this.requiered = false;
            this.unselectedOption = {
                hidden: false,
                display: (this.msg['au.COMPONENT.KtsDepartmentComponent.select.department'])
            };
        }
        else {
            this.requiered = true;
        }
        this.departmentKey = jsonpath.value(this.col, '$.params.department.key') || '';
        this.sectionKey = jsonpath.value(this.col, '$.params.section.key') || '';
        this.dispNameKey = jsonpath.value(this.col, '$.params.name.key') || '';
        this.departmentService.setBaseUrl('/v1/gen/department-m-service?query={"orderByList":[{"name":"id","direction":"asc"}]}');
        this.departmentService.getRecord().subscribe(function (rec) {
            var departmentOptions = [];
            // 必須選択の場合の未選択のラベル設定
            if (_this.requiered == true) {
                departmentOptions.push(_this.getDepartmentOption());
            }
            var sectionOptions = {};
            for (var _i = 0, _a = rec.items; _i < _a.length; _i++) {
                var item = _a[_i];
                departmentOptions.push({ code: item.id, display: item.department_name, display_name: item.display_department_name });
                sectionOptions[item.id] = [_this.getSectionOption()];
                _this.departmentService.sortItems(item.section_m);
                for (var _b = 0, _c = item.section_m; _b < _c.length; _b++) {
                    var sec = _c[_b];
                    sectionOptions[item.id].push({ code: sec.id, display: sec.section_name, display_name: sec.display_section_name });
                }
            }
            sectionOptions[''] = [_this.getSectionOption()];
            _this.departmentOptions = departmentOptions;
            _this.sectionOptions = sectionOptions;
            _this.setName();
        });
        this.setSection();
    };
    KtsDepartmentComponent.prototype.getDepartmentOption = function () {
        return { code: '', display: this.msg['au.COMPONENT.KtsDepartmentComponent.select.department'], display_name: '' };
    };
    KtsDepartmentComponent.prototype.getSectionOption = function () {
        return { code: '', display: this.msg['au.COMPONENT.KtsDepartmentComponent.select.section'], display_name: '' };
    };
    KtsDepartmentComponent.prototype.onChangeDepartment = function (e) {
        this.changeValFlg = true;
        this.changeVal.emit({ key: this.departmentKey, val: e.val });
        this.changeVal.emit({ key: this.sectionKey, val: '' });
        this.setName();
    };
    KtsDepartmentComponent.prototype.onChangeSection = function (e) {
        this.changeValFlg = true;
        this.changeVal.emit({ key: this.sectionKey, val: e });
        this.setName();
    };
    KtsDepartmentComponent.prototype.setSection = function () {
        if (typeof this.section === 'undefined' || this.section === null) {
            this.changeVal.emit({ key: this.sectionKey, val: '' });
            this.setName();
        }
    };
    KtsDepartmentComponent.prototype.setName = function () {
        if (this.dispNameKey && this.val) {
            var dispName = '';
            var depVal = this.val[this.departmentKey];
            var secVal = this.val[this.sectionKey];
            if (depVal && secVal) {
                if (this.sectionOptions[depVal]) {
                    for (var _i = 0, _a = this.sectionOptions[depVal]; _i < _a.length; _i++) {
                        var option = _a[_i];
                        if (option.code && secVal && option.code.toString() === secVal.toString()) {
                            dispName = option.display_name;
                            break;
                        }
                    }
                }
            }
            else if (depVal) {
                for (var _b = 0, _c = this.departmentOptions; _b < _c.length; _b++) {
                    var option = _c[_b];
                    if (option.code && option.code.toString() === depVal.toString()) {
                        dispName = option.display_name;
                        break;
                    }
                }
            }
            this.changeVal.emit({ key: this.dispNameKey, val: dispName });
        }
    };
    KtsDepartmentComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
    };
    KtsDepartmentComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'kts-column-department',
                    template: "<ul [key]=\"key\" [col]=\"col\" columnDir>\n  <ng-template [ngIf]=\"departmentKey\">\n    <li *ngIf=\"!col.readonly\" class=\"form_li\">\n      <column-select [key]=\"key\" [componentName]=\"componentName\" [index]=\"index\" [col]=\"{\n        key: departmentKey,\n        controlType: 'select',\n        required: requiered,\n        params: {options: departmentOptions, unselectedOption: unselectedOption}\n      }\" [val]=\"val[departmentKey]\" [msg]=\"msg\" (changeVal)=\"onChangeDepartment($event)\"></column-select>\n    </li>\n    <li *ngIf=\"col.readonly\" class=\"form_li\">\n      <column-formreadonly [componentName]=\"componentName\" [index]=\"index\" [col]=\"{\n        key: departmentKey,\n        controlType: 'select',\n        params: {options: departmentOptions}\n      }\" [val]=\"val[departmentKey]\" [msg]=\"msg\"></column-formreadonly>\n    </li>\n  </ng-template>\n  <ng-template [ngIf]=\"sectionKey\">\n    <li *ngIf=\"!col.readonly\" class=\"form_li\">\n      <select name=\"{{ colKey }}\" attr.name=\"{{ colKey }}\" [(ngModel)]=\"val[sectionKey]\" (change)=\"onChangeSection(val[sectionKey])\"\n              [key]=\"key\" [col]=\"{key: sectionKey, controlType: 'select'}\" columnDir>\n        <option *ngFor=\"let option of sectionOptions[val[departmentKey]]\" [value]=\"option.code\">{{ option.display }}</option>\n      </select>\n    </li>\n    <li *ngIf=\"col.readonly\" class=\"form_li\">\n      <column-formreadonly [componentName]=\"componentName\" [index]=\"index\" [col]=\"{\n        key: sectionKey,\n        controlType: 'select',\n        params: {options: sectionOptions[val[departmentKey]]}\n      }\" [val]=\"val[sectionKey]\" [msg]=\"msg\"></column-formreadonly>\n    </li>\n  </ng-template>\n</ul>\n"
                }] }
    ];
    /** @nocollapse */
    KtsDepartmentComponent.ctorParameters = function () { return [
        { type: ColumnService },
        { type: ColumnBaseService },
        { type: KtsDepartmentService }
    ]; };
    KtsDepartmentComponent.propDecorators = {
        department: [{ type: Input }],
        section: [{ type: Input }],
        name: [{ type: Input }]
    };
    return KtsDepartmentComponent;
}(ColumnBaseComponent));
export { KtsDepartmentComponent };
//# sourceMappingURL=department.component.js.map